import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FormControl, FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import Selectr from 'mobius1-selectr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EnduserService } from 'src/app/services/enduser/enduser.service';

@Component({
    selector: 'app-add-enduser',
    templateUrl: './add-enduser.component.html',
    styleUrls: ['./add-enduser.component.scss']
  })
  export class AddEnduserComponent implements OnInit {
    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    public isEdit: boolean;
    public title: string = 'Add Patient';
    public userId: any;
    citylistForDropdown: any;
    public pages: any;

    public ProspectTouchSubmit = false;
    public nextSaveBtnLoding = false;
    public addEnduserForm!: FormGroup;
    public dateInputFormat: any;
    public statelistForDropdown = [];
    public citylistForDropdownByState = [];
    public salesRep = [];
    public areacodelistForDropdown = [];
    displayNotEditedDateTime: any;
    selectrSingle: any;

    optionsSingle = {
        placeholder: 'Select Runner',
        // data: []
    };
    existRunnerHide: boolean;
    checkExisit=true;
    selectorMultiple: Selectr;
    customer_id: string;

    constructor(
        private formBuilder: FormBuilder,
        private enduserService: EnduserService,
        private toastr: ToastrService,
        private router: Router,
        public datepipe: DatePipe,
        private actRoute: ActivatedRoute,
        private ngbModal: NgbActiveModal,

    ) {

        this.actRoute.paramMap.subscribe(params => {

            this.userId = params.get('id');
            this.checkExisit =false;
        });




    }

    ngOnInit(): void {
        console.log(this.props.customer_id);
       // this.dateInputFormat = localStorage.getItem('dateFormat').toUpperCase();
        this.addEnduserForm = this.formBuilder.group({
          first_name: ['', Validators.required],
          last_name: ['', Validators.required],
            phone: ['', [Validators.required, Validators.pattern('^[0-9]{7,15}$')]],
            email: ['', Validators.required],
            gender: ['', Validators.required],
            date_of_birth: ['', Validators.required],
            client_id : [1],
            customer_id : [this.props.customer_id],
        });



    }




    addLablocation() {
        this.ProspectTouchSubmit = true;

        if (this.addEnduserForm.valid) {


            this.nextSaveBtnLoding = true;

            this.nextSaveBtnLoding = true;
            if (this.addEnduserForm.value.date_of_birth) {
              this.addEnduserForm.value.date_of_birth = this.datepipe.transform(this.addEnduserForm.value.date_of_birth, 'YYYY-MM-d')
          } else {
              this.addEnduserForm.value.date_of_birth = ''
          }
            this.enduserService.onSaveendUserWeb(this.addEnduserForm.value).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.closeModal();
                        this.toastr.success('Customer added successfully');
                        // this.modalRef.close({value: res});
                      } else {
                        if (res.message) {
                            this.toastr.error(`${res.message}`);
                        } else {
                            // this.toastr.error(`Customer Not Added Successfully`);
                            this.toastr.error(res.error);
                        }
                    }
                },
                (err: any) => {
                    this.toastr.error(`${err}`);

                },
                () => {
                    this.nextSaveBtnLoding = false;
                    this.ProspectTouchSubmit = false;
                }
            );

        }

    }


    get ProspectInfo() {
        return this.addEnduserForm.controls;
    }

    closeModal() {
      this.passEntry.next(this.pages);
      this.ngbModal.close();
  }



}
